import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HeaderComponent } from './header.component';
import { FooterComponent } from './footer.component';
import { APP_BASE_HREF } from '@angular/common';
import { PolicyInfoService } from './policyinfo.service';
import { ConfigService } from './config.service';
import { HttpClientModule } from '@angular/common/http';
import { BrandingService } from './branding.service';
import { AppComponent, DollarsPipe, CentsPipe, PhonePipe, PhoneFormatDirective, SafePipe, LowerCaseUrlSerializer } from './app.component';
import { ApplyComponent } from './app.applycomponent';
import { ThankYouComponent } from './thankyou/app.thankyoucomponent';
import { RouterModule, Routes, UrlSerializer } from '@angular/router';
import { ContactUsComponent } from './contactus/app.contactuscomponent';


const router: Routes = [
  { path: '', component: ThankYouComponent, pathMatch: 'full' },
  { path: 'apply', component: ApplyComponent },
  { path: 'thankyou', component: ThankYouComponent },
  { path: 'contactus', component: ContactUsComponent }
];

@NgModule({
  declarations: [
    AppComponent,
    ApplyComponent,
    ContactUsComponent,
    ThankYouComponent,
    HeaderComponent,
    FooterComponent,
    DollarsPipe,
    CentsPipe,
    PhonePipe,
    SafePipe,
    PhoneFormatDirective
  ],
  imports: [
    BrowserModule,
    RouterModule.forRoot(
      router,
      {
        enableTracing: false // set it to false to disable console logs in browser
      }),
    HttpClientModule
  ],
  exports: [RouterModule],
  providers: [
    { provide: APP_BASE_HREF, useValue: '/' },
    { provide: UrlSerializer, useClass: LowerCaseUrlSerializer },
    PolicyInfoService,
    ConfigService,
    BrandingService,
    PhonePipe
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
